import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener("DOMContentLoaded", function() {

  // window.addEventListener("load", function() {

    (function getToKnowSlider() {

      const sliders = document.querySelectorAll(".hkbis-top-courses-animation");

      if (sliders && sliders.length && sliders.length > 0) {

        jQuery('html').css('scroll-behavior', 'auto');

        [...sliders].forEach(slider => {

          const classID = slider.dataset.classid;
          const sorting = slider.dataset.sorting;
          const slideCount = slider.dataset.numberOfSlides;
          const currentTheme = slider.dataset.currentTheme;

          let catIDs = [];
          for (let i=0; i <= slideCount - 1; i++) {
            catIDs.push(slider.dataset['cat'+i+'id']);
          }

          let resultContainers = [];
          for (let i=0; i <= slideCount - 1; i++) {
            resultContainers.push([]);
            const containers = slider.querySelectorAll('#cat-'+i+'-container');
            containers.forEach(container => {
              resultContainers[i].push(container);
            })
          }

          let loadedContentForIndex = [];
          for (let i=0; i <= slideCount - 1; i++) {
            loadedContentForIndex.push(false);
          }

          let lastSlider = 0;
          let endIndex = slideCount - 1;

          const blockID = slider.querySelector(".block__hkbis-top-courses--block-id").id;

          const navLinksMobile = [...slider.querySelectorAll('.block__hkbis-top-courses__nav-container-mobile a')];
          const navLinksDesktop = [...slider.querySelectorAll('.block__hkbis-top-courses__nav-container-desktop a')];
          const navLinksDesktopIcons = [...slider.querySelectorAll('.desktop-nav-target-icon')];

          const mobileNavSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-top-courses__nav-slider');
          const contentSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-top-courses__content-slider');
          const contentLoader = jQuery('#' + blockID.toString() + ' .lottie-animation-container');
          const textSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-top-courses__text-slider');

          const desktopNavElements = [...slider.querySelectorAll('.desktop-nav-target-select')];
          const desktopNavDataElements = [...slider.querySelectorAll('.desktop-nav-data')];

          const nextButton = slider.querySelector('.slick-next');
          const nextButtonSvg = nextButton?.querySelector('svg');
          const prevButton = slider.querySelector('.slick-prev');
          const prevButtonSvg = prevButton?.querySelector('svg');

          const buttonColors = [
            ["fill-classic-cherry", "fill-dark-grass", "fill-pride-orange", "fill-pastel-orange-light"],
            ["fill-classic-cherry", "fill-dark-grass", "fill-pride-orange", "fill-pastel-orange-light"],
            ["fill-classic-cherry", "fill-dark-grass", "fill-pride-orange", "fill-pastel-orange-light"],
          ];

          const navButtonBgs = [
            ["bg-classic-primary", "bg-dark-grass", "bg-pride-orange", "bg-pastel-orange-light"],
            ["bg-classic-primary", "bg-dark-grass", "bg-pride-orange", "bg-pastel-orange-light"],
            ["bg-classic-primary", "bg-dark-grass", "bg-pride-orange", "bg-pastel-orange-light"],
          ];

          const navButtonBorders = [
            ["border-classic-white", "border-dark-white", "border-pride-white", "border-pastel-black"],
            ["border-classic-white", "border-dark-white", "border-pride-white", "border-pastel-black"],
            ["border-classic-white", "border-dark-white", "border-pride-white", "border-pastel-black"],
          ];

          const navButtonFills = [
            ["fill-classic-white", "fill-dark-black", "fill-pride-black", "fill-pastel-black"],
            ["fill-classic-white", "fill-dark-black", "fill-pride-black", "fill-pastel-black"],
            ["fill-classic-white", "fill-dark-black", "fill-pride-black", "fill-pastel-black"],
          ];

          buttonColors[0].forEach(c => navLinksDesktopIcons.forEach(icon => icon.classList.add(c)));

          navButtonBgs[0].forEach(c => {nextButton?.classList.add(c); prevButton?.classList.add(c)});
          navButtonBorders[0].forEach(c => {nextButton?.classList.add(c); prevButton?.classList.add(c)});
          navButtonFills[0].forEach(c => {nextButtonSvg?.classList.add(c); prevButtonSvg?.classList.add(c)});

          let navDesktopDataInitState = [];
          let navDesktopData = [];
          desktopNavDataElements.forEach(element => {
            navDesktopData.push({
              text: element.dataset.text,
              index: element.dataset.index,
            });
          });
          navDesktopDataInitState = navDesktopData;

          const contentSlides = [...slider.querySelectorAll('.block__hkbis-top-courses__content-slider > .slick-list > .slick-track > .slick-slide')];
          const contentSliderSlickList = slider.querySelector('.block__hkbis-top-courses__content-slider > .slick-list');
          const contentSliderSlickTrack = slider.querySelector('.block__hkbis-top-courses__content-slider > .slick-list > .slick-track');

          const textSlides = [...slider.querySelectorAll('.block__hkbis-top-courses__text-slider > .slick-list > .slick-track > .slick-slide')];
          const textSliderSlickTrack = slider.querySelector('.block__hkbis-top-courses__text-slider > .slick-list > .slick-track');

          const resizeVerticalSliderInner = () => {
            console.log('resize');

            let minHeight = 0;
            contentSlides.forEach(slide => {
              slide.style.minHeight = 'unset';
              const currentHeight = slide.getBoundingClientRect().height;
              if (currentHeight >= minHeight) {
                minHeight = currentHeight;
              }
            });
            contentSlides.forEach(slide => {
              slide.style.minHeight = minHeight.toString() + 'px';
            });
            contentSliderSlickTrack.style.minHeight = (minHeight * slideCount).toString() + 'px';
            contentSliderSlickList.style.minHeight = minHeight.toString() + 'px';

            minHeight = 0;
            textSlides.forEach(slide => {
              slide.style.minHeight = 'unset';
              const currentHeight = slide.getBoundingClientRect().height;
              if (currentHeight >= minHeight) {
                minHeight = currentHeight;
              }
            });
            textSlides.forEach(slide => {
              slide.style.minHeight = minHeight.toString() + 'px';
            });
            textSliderSlickTrack.style.minHeight = (minHeight * slideCount).toString() + 'px';
          }

          const resizeVerticalSlider = () => {
            resizeVerticalSliderInner();

            // called again for lazy loaded images
            if (currentTheme === 'HK Master') {
              setTimeout(resizeVerticalSliderInner, 300)
            }
          }
          resizeVerticalSlider();
          const listeners = ['resize', 'top-courses-loaded'];
          listeners.forEach(listener => {
            document.addEventListener(listener, function() {
              resizeVerticalSlider();
            });
          });

          const setActiveMenu = (index) => {
            navLinksMobile.forEach(link => {
              link.classList.remove(['active']);
            })
            if(navLinksMobile.hasOwnProperty(index)) {
              navLinksMobile[index].classList.add(['active']);
            }

            buttonColors[lastSlider % 3].forEach(c => navLinksDesktopIcons.forEach(icon => icon.classList.remove(c)));
            buttonColors[index % 3].forEach(c => navLinksDesktopIcons.forEach(icon => icon.classList.add(c)));

            navButtonBgs[lastSlider % 3].forEach(c => {nextButton?.classList.remove(c); prevButton?.classList.remove(c)});
            navButtonBgs[index % 3].forEach(c => {nextButton?.classList.add(c); prevButton?.classList.add(c)});

            navButtonBorders[lastSlider % 3].forEach(c => {nextButton?.classList.remove(c); prevButton?.classList.remove(c)});
            navButtonBorders[index % 3].forEach(c => {nextButton?.classList.add(c); prevButton?.classList.add(c)});

            navButtonFills[lastSlider % 3].forEach(c => {nextButtonSvg?.classList.remove(c); prevButtonSvg?.classList.remove(c)});
            navButtonFills[index % 3].forEach(c => {nextButtonSvg?.classList.add(c); prevButtonSvg?.classList.add(c)});
          }

          const setActiveDesktopMenu = (index) => {
            arrayRotate(index);
            animateDestkopNav(lastSlider < index);
          }

          const setActiveDesktopMenuScroll = (index) => {
            if(navDesktopData[0].index != index) {
              arrayRotateScroll(index);
              animateDestkopNav(lastSlider < index);
            }
          }

          const animateDestkopNav = (reverse) => {

            if(reverse) {
              desktopNavElements.forEach(element => {
                gsap.to(element, {y: 20, opacity: 0, animation: "power1", duration: 0.15 });
              });
            } else {
              desktopNavElements.forEach(element => {
                gsap.to(element, {y: -20, opacity: 0, animation: "power1", duration: 0.15 });
              });
            }

            setTimeout(function() {
              desktopNavElements.forEach((desktopNavElement, desktopNavElementIndex) => {
                desktopNavElements[desktopNavElementIndex].innerHTML = navDesktopData[desktopNavElementIndex].text;
              });

              if(reverse) {
                desktopNavElements.forEach(element => {
                  gsap.fromTo(element, {y: -20, opacity: 0, animation: "power1", duration: 0.15 }, {y: 0, opacity: 1});
                });
              } else {
                desktopNavElements.forEach(element => {
                  gsap.fromTo(element, {y: 20, opacity: 0, animation: "power1", duration: 0.15 }, {y: 0, opacity: 1});
                });
              }
            }, 300);
          };

          const arrayRotate = (times) => {
            for(let i = 0; i < times; i++) {
              navDesktopData.push(navDesktopData.shift());
            }
          }

          const arrayRotateScroll = (index) => {
            for(let i = 0; i < 2; i++) {
              if(navDesktopData[0].index == index) {
                break;
              }
              navDesktopData.push(navDesktopData.shift());
            }
          }

          const moveSliders = (index) => {

            if (index < 0) {
              index = endIndex;
            }
            if (index > endIndex) {
              index = 0;
            }

            if (!loadedContentForIndex[index]) {
              loadedContentForIndex[index] = true;
              loadCourses(index, classID, catIDs[index], resultContainers[index], true);
            }

            setActiveMenu(index);

            mobileNavSlider.slick('slickGoTo', index);
            contentSlider.slick('slickGoTo', index);
            textSlider.slick('slickGoTo', index);

            lastSlider = index;
          }

          const moveSlidersScroll = (index) => {
            moveSliders(index);
            setActiveDesktopMenuScroll(index);
          }

          // --------------------------------------------------------
          // --------------------------------------------------------


          if(navLinksMobile.hasOwnProperty(0)) {
            navLinksMobile[0].classList.add(['active']);
          }

          // ScrollTrigger.matchMedia({
          //   "(min-width: 768px)": function () {
          //     let timeline = gsap.timeline({
          //       scrollTrigger: {
          //         trigger: slider,
          //         pin: slider,
          //         pinSpacing: false,
          //         anticipatePin: 1,
          //         scrub: 1,
          //         start: "center center",
          //         end: "+=3000",
          //         ease: "none",
          //       },
          //       ease: "none",
          //     });

          //     timeline.duration(1000);

          //     for (let i = 0; i < numberOfSlides; i++) {
          //       timeline.add( ["slide-" + i.toString(), gsap.delayedCall(100, moveSlidersScroll, [i])]);
          //     }
          //     timeline.add( ["end", gsap.delayedCall(100, undefined, null)] );
          //   },
          // });

          navLinksMobile.forEach(link => {
            link.addEventListener('click', function() {
              const index = link.dataset.index;
              moveSliders(index);
              setActiveDesktopMenu(index);
            });
          });

          navLinksDesktop.forEach(link => {
            link.addEventListener('click', function() {
              const index = link.dataset.index;
              moveSliders(navDesktopData[index].index);
              setActiveDesktopMenu(index);
            });
          });

          mobileNavSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            moveSliders(nextSlide);
          });

          nextButton?.addEventListener('click', function(e){
            moveSliders(lastSlider + 1);
          });

          prevButton?.addEventListener('click', function(e){
            moveSliders(lastSlider - 1);
          });

          const setLoading = (bool) => {
            if (bool) {
              contentLoader.show();
            } else {
              contentLoader.hide();
            }
          }

          const loadCourses = (index, classID, catID, resultContainers, useMoveSliders = false) => {
            setLoading(true);
            let params = {};
            params["classID"] = classID;
            params["sorting"] =  sorting.toString();
            params["catID"] =  catID.toString();
            params["index"] =  index.toString();

            let data = formatData(params);

            jQuery.ajax({
              type: 'post',
              url: ajaxurl,
              data: {action: 'top_courses_ajax', data},
              success: function (response) {
                resultContainers.forEach(resultContainer => resultContainer.innerHTML = response)
                if (useMoveSliders) {
                  moveSliders(index);
                }
                document.dispatchEvent(new CustomEvent("courses-loaded-ajax"));
                document.dispatchEvent(new CustomEvent("top-courses-loaded"));
                document.dispatchEvent(new CustomEvent("reload-draggable-sliders"));
                setLoading(false);
              },
              error: function () {
                console.log("Error");
              }
            });
          }

          loadedContentForIndex[0] = true;

          let firstTrigger = gsap.timeline({
            scrollTrigger: {
              trigger: contentSlider,
              start: 'top bottom',
              onEnter: () => {console.log('init first top courses');loadCourses(0, classID, catIDs[0], resultContainers[0], true)},
              once: true,
            },
          });
        });

        function formatData(params) {
          let data  = {};
          for (let param in params) {
              if (params[param] != "") {
                  data[param] = params[param];
              }
          }
          return data;
        }
      }
    })();
  // });
});



